
import { Provider } from 'react-redux';
import { AppRouter } from "./router/AppRouter"
import { store } from './store';
import { AppTheme } from "./theme";

import dayjs from 'dayjs';
import 'dayjs/locale/es';
dayjs.locale('es');





export const App = () => {


    return (

      <Provider store={ store } >
          <AppTheme>
            <AppRouter />
          </AppTheme>
      </Provider>

    )




}
